export enum BookingStatusEnum {
  Draft = "Draft",
  New = "New",
  Rejected = "Rejected",
  Routed = "Routed",
  OnHold = "OnHold",
  Canceled = "Canceled",
  // RYDE-8171: a meal-only booking covered by a production run (never Routed, never a ride).
  Approved = "Approved",
}

export const readOnlyBookTimeStatus = new Set<BookingStatusEnum>([
  BookingStatusEnum.Routed,
  BookingStatusEnum.Rejected,
  BookingStatusEnum.Canceled,
]);
